import {Link} from 'react-router';
import './Login.css';

/** Catch-all for unknown URLs, so a mistyped or stale link never renders a blank page. */
export default function NotFound() {
  return (
    <main className="auth-page">
      <section className="auth-card" aria-labelledby="not-found-title">
        <h1 id="not-found-title">Page not found</h1>
        <p>The page you are looking for does not exist or has moved.</p>
        <Link className="btn btn-primary auth-primary" to="/">
          Go to the home page
        </Link>
      </section>
    </main>
  );
}
